var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3"
  }, [_c('h5', [_vm._v("通路清單")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.unbindList.length < 1 || _vm.isUnbinding
    },
    on: {
      "click": _vm.handleUnbind
    }
  }, [_vm._v("解除綁定")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields,
      "busy": _vm.isFetchSameCustomerList
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(edit)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.id,
            "disabled": data.item.merchant_type_name.type === 'LINE'
          },
          model: {
            value: _vm.unbindList,
            callback: function callback($$v) {
              _vm.unbindList = $$v;
            },
            expression: "unbindList"
          }
        })];
      }
    }, {
      key: "cell(picture)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: 'CustomerDetailEdit'
              });
            }
          }
        }, [_c('BIconPencilFill', {
          attrs: {
            "aria-hidden": "true"
          }
        })], 1), _c('b-avatar', {
          attrs: {
            "variant": "secondary",
            "src": data.item.picture,
            "size": "2rem"
          }
        })], 1)];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(data.item.name) + " ")])];
      }
    }, {
      key: "cell(computed_merchant_types)",
      fn: function fn(data) {
        return [data.item.merchant_type_name ? _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.item.merchant_type_name.type_name || '未知'))]) : _vm._e()];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }